<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="PrescriptionDrug">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            处方药品列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <el-button type="primary" plain @click.native="toggleModalAdd">查询药品项目</el-button>
                    <el-button type="primary" :disabled="disabledDrug" plain @click="handleDrug">取药</el-button>
                    <!-- <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <el-select v-model="medicinerCode" placeholder="请选择医生" clearable style="margin:0 5px">
                            <el-option
                                    v-for="item in medicinerList"
                                    :key="item.medicinerCode"
                                    :label="item.name"
                                    :value="item.medicinerCode">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="status"
                            style="margin:0 10px;width:200px"
                            placeholder="请选择入住状态">
                            <el-option
                                v-for="item in statusValue"
                                :key="item.val"
                                :label="item.name"
                                :value="item.val">
                            </el-option>
                        </el-select>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div> -->
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" default-expand-all highlight-current-row @row-click='rowClick'>
                        <el-table-column type="expand" v-if="tableData.length">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item :label="value.name+':'" v-for="(value,i) in props.row.children" :key="i">
                                        <span>数量：{{value.number}}</span><br>
                                        <span>单价：{{value.price}}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="药品项目名称"></el-table-column>

                        <el-table-column prop="price"  label="药品总费用(元)"></el-table-column>

                        <el-table-column prop="status" label="药品状态">
                            <template slot-scope="scope">
                                <el-tag v-show="scope.row.status==1">待取药</el-tag>
                                <el-tag type="success" v-show="scope.row.status==2">已取药</el-tag>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                disabledDrug:true,
                tableData:[],
                totalItems: 0,
                pageSize:20,
                medicinerCode:'',
                prescriptionDrugCode:'',
                consultationDrugRelCode:'',
                selectInfo:'',
                serialNumber:'',
                medicinerList:[],
                currentPage:1,
                th:0,
                name:'',
                idCard:'',
                status:-1,
            }
        },
        components:{
            Add
        },
        created(){
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            statusTitle(column){
                if(column==1){
                    return '待药品'
                }else{
                    return '已药品'
                }
            },
            rowClick(row){
                this.disabledDrug=true
                this.selectInfo=row
                if(row.status==1){
                    this.disabledDrug=false
                }   
            },
            handleDrug() {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PrescriptionDrug/TakeDrug",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        prescriptionDrugCode:this.prescriptionDrugCode,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.$message.error('操作成功')
                        this.disabledDrug=true
                        this.getTableData()
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
                // this.$refs.myEdit.init(row);
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            getTableData(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'PrescriptionDrug/getNotCheck',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        serialNumber:this.serialNumber,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data= response.data.data;
                        this.tableData=this.getTable(data)
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getList(data,serialNumber){
                this.serialNumber=serialNumber
                this.tableData=this.getTable(data)
                this.prescriptionDrugCode=data[0].prescriptionDrugCode
            },
            getTable(data){
                var tableData=[]
                for(var i in data){
                    var obj={
                        code:data[i].prescriptionDrugCode,
                        name:data[i].prescriptionDrugDTO.name,
                        status:data[i].prescriptionDrugDTO.status,
                        price:data[i].prescriptionDrugDTO.sumPrice,
                        children:[]
                    }
                    var List=data[i].prescriptionDrugDTO.prescriptionDrugItemDTOList
                    for(var j in List){
                        var obj1={
                            name:List[j].waresDrug.name,
                            number:List[j].waresDrugNumber,
                            price:List[j].waresDrug.price,
                        }
                        obj.children.push(obj1)
                    }
                    tableData.push(obj)
                }
                console.log(tableData)
                return tableData
            }

        }
    }
</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        /* width: 100%; */
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
<style lang="scss" scoped>
    .PrescriptionDrug /deep/ .el-table__body tr.current-row>td {
        background-color: rgb(102, 177, 255);;
        color:#fff;
    }
</style>
